import ConfirmModalAdjustments from './ConfirmModalAdjustments'

export default ConfirmModalAdjustments
